import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			position: 'initial !important',
		},

		text: {
			textAlign: ({ metaData }) => metaData.alignment?.metaValue,

			[theme.breakpoints.down('xs')]: {
				'& *': {
					textAlign: ({ metaData }) => metaData.mobileAlignment?.metaValue || null,
				},
			},
		},
		row: {
			overflow: 'hidden',
			padding: 2,
			margin: -2,
			'&:not(:last-child)': {
				marginBottom: `calc(${theme.spacing(5)} - 2px)`,
			},
		},
		grid: {
			margin: theme.spacing(-2.5, -4),
			width: `calc(100% + ${theme.spacing(8)})`,
			justifyContent: ({ metaData }) => metaData.alignment?.contentAlignment(),
		},

		gridItem: {
			padding: theme.spacing(2.5, 4),
		},
	}),
	{ name: 'FAQ-FAQ1' },
)

export default useStyles
